import React from "react";
import Login from "../pages/auth-pages/login";
import ResetPassword from "../pages/auth-pages/reset-password";
import Color from "../pages/settings/color/index";
import User from "app/pages/settings/user";

import Page from "@jumbo/shared/Page";
import AddUser from "app/pages/settings/user/add-update-user";
import Role from "app/pages/settings/role";
import PrivateRoute from "./PrivateRoute";
import Error404 from "app/pages/pagenotfound";
import Home from "app/pages/home/Home";
import Product from "app/pages/product";
import Permissions from "app/pages/settings/role/permission";
import Error401 from "app/pages/401";
import SetPassword from "app/pages/auth-pages/set-password";
import ChangePassword from "app/pages/auth-pages/change-password";
import {
  COLORS,
  HOME,
  MANAGE_PERMISSION,
  PRODUCT_VARIANTS,
  PRODUCTS,
  VENDORS,
  ROLES,
  USERS,
  USERS_ADD,
  USERS_EDIT,
  PRODUCT_ADD,
  PRODUCT_EDIT,
  LOGS_URL,
  SIZES,
  SIZE_CHARTS,
  FABRICS,
  CATEGORIES,
  PURCHASE_ORDERS,
  PURCHASE_ORDERS_ADD,
  PURCHASE_ORDERS_EDIT,
  PLATFORMS,
  BILL_LIST,
  BILL_ADD_From_PO,
  EXPENSE_TYPE,
  CASH_BOOK,
  CHEQUE_BOOK,
  CASH_CREDIT_DEBIT,
  CHEQUE_CREDIT_DEBIT,
  SALES_INVOICE,
  SALES_INVOICE_ADD,
  SALES_INVOICE_EDIT,
  BILL_VIEW,
  LEDGER,
  PROFIT_LOSS,
  BALANCE_SHEET,
  FLIPKART,
  FLIPKART_ORDERS_LIST,
  INCOME_TYPE,
  BILL_ADD,
  BILL_EDIT,
  SAMPLES,
  SAMPLES_ADD,
  SAMPLES_EDIT,
  SAMPLES_RETURN,
  SAMPLES_RETURN_LIST,
  AUDITS,
  AUDITS_ADD,
  AUDITS_LIST,
  UNIT_ECONOMICS,
  MEESHO,
  MEESHO_DASHBOARD,
  MEESHO_BULK_IMPORT,
  MEESHO_PAYMENT_IMPORT,
  MEESHO_ORDERS_LIST,
  MEESHO_RTO,
  MEESHO_REPORT,
  ORDER_MANAGEMENT,
  ORDER_MANAGEMENT_IMPORT,
  ORDER_MANAGEMENT_LIST,
  ORDER_MANAGEMENT_STATISTICS,
  ORDER_MANAGEMENT_RETURNS,
  ORDER_MANAGEMENT_PAYMENT_PROCESS,
  DEBIT_NOTE,
  DEBIT_NOTE_LIST,
  ORDER_MANAGEMENT_STATISTICS_LIST,
  ORDER_MANAGEMENT_MARKETING_EXPENSES,
  ORDER_MANAGEMENT_FINANCE_DASHBOARD,
  ORDER_MANAGEMENT_PAYOUT_BREAKDOWN,
  ATTENDANCE_QR,
  USERS_ATTENDANCE_LOG,
  ORDER_MANAGEMENT_PRODUCT_REPORT,
  OUTSTANDING_REPORT,
  ORDER_MANAGEMENT_ORDER_HISTORY,
  ORDER_MANAGEMENT_PAYMENT_MARKETING_EXPENSES_HISTORY,
  MYNTRA,
  MYNTRA_IMPORT,
  MYNTRA_ORDERS_LIST,
  MYNTRA_RETURNS,
  MYNTRA_PAYMENTS,
  MYNTRA_PRODUCT_REPORT,
  MYNTRA_STATISTICS,
  MYNTRA_STATISTICS_LIST,
  MYNTRA_FINANCE_DASHBOARD,
  MYNTRA_MARKETING_EXPENSES,
  MYNTRA_RETURN_REASON_ANALYSIS,
  ORDER_MANAGEMENT_RETURN_REASON_ANALYSIS,
  FLIPKART_IMPORT,
  FLIPKART_PAYMENTS,
  FLIPKART_PRODUCT_REPORT,
  FLIPKART_STATISTICS,
  FLIPKART_STATISTICS_LIST,
  FLIPKART_FINANCE_DASHBOARD,
  INVENTORY_MANAGEMENT,
  APP_SALES_REPORT,
  ORDER_LABEL_IMPORT,
} from "./constant";
import OfficeVendor from "app/pages/settings/vendor";
import AddProduct from "app/pages/product/add-edit-product";
import ProductVariant from "app/pages/product/variant-list";
import Logs from "app/pages/logs";
import Size from "app/pages/settings/size";
import SizeChart from "app/pages/settings/size-chart";
import Fabric from "app/pages/settings/fabric";
import Category from "app/pages/settings/category";
import PurchaseOrder from "app/pages/fabric/purchase-order";
import AddAndUpdatePurchaseOrder from "app/pages/fabric/purchase-order/add-purchase-order";
import Platform from "app/pages/settings/platform";
import BillList from "app/pages/fabric/bill";
import AddAndUpdateBill from "app/pages/fabric/bill/add-bill";
import ExpenseType from "app/pages/settings/expenseType";
import CashBookPage from "app/pages/cashAndCheque/view/cash";
import ChequeBookPage from "app/pages/cashAndCheque/view/cheque";
import CreditAndDebit from "app/pages/cashAndCheque/creditAndDebit";
import SalesInvoice from "app/pages/sales-invoice";
import AddAndUpdateSalesInvoice from "app/pages/sales-invoice/add-invoice";
import Ledger from "app/pages/ledger/view";
import ProfitLoss from "app/pages/profitLoss/view";
import BalanceSheet from "app/pages/balanceSheet/view";
import IncomeType from "app/pages/settings/incomeType";
import AddAndUpdateBillOther from "app/pages/fabric/bill/add-bill-other";
import SampleManagement from "app/pages/samples";
import AddEditSample from "app/pages/samples/add-edit-sample";
import ReturnSample from "app/pages/samples/return-sample";
import SampleManagementReturn from "app/pages/samples/return-list";
import Audit from "app/pages/audit";
import AddEditAudit from "app/pages/audit/add-edit-audit";
import AuditList from "app/pages/audit/list";
import FlipkartUnitEconomics from "app/pages/unit-economics";
import MeeshoMenu from "app/pages/meesho";
import MeeshoDashboard from "app/pages/meesho/dashboard";
import MeeshoBulkImport from "app/pages/meesho/orders-import";
import MeeshoPaymentImport from "app/pages/meesho/payment-import";
import MeeshoOrdersList from "app/pages/meesho/orders-list";
import MeeshoRTO from "app/pages/meesho/rto";
import MeeshoReport from "app/pages/meesho/report";
import OrderManagement from "app/pages/order-management";
import OrderImport from "app/pages/order-management/import";
import OrderList from "app/pages/order-management/orders-list";
import OrderStatistics from "app/pages/order-management/statistics";
import ReturnsList from "app/pages/order-management/returns";
import PaymentList from "app/pages/order-management/payments-list";
import DebitNote from "app/pages/fabric/bill/debit-note";
import DebitNoteList from "app/pages/fabric/bill/debit-note-list";
import OrderStatisticsList from "app/pages/order-management/statistics/list";
import MarkingExpensesList from "app/pages/order-management/marking-expenses";
import FinanceDashboard from "app/pages/order-management/finance-dashboard";
import PayoutBreakdown from "app/pages/order-management/payout-breakdown";
import Attendance from "app/pages/attendance";
import UserAttendanceList from "app/pages/settings/user/attendance-list";
import ProductReportList from "app/pages/order-management/product-report";
import PaymentReport from "app/pages/paymentReport/view";
import OrderHistory from "app/pages/order-management/order-history";
import OrderMarketingExpensesHistory from "app/pages/order-management/order-marketing-expenses-history";
import MyntraMenu from "app/pages/myntra";
import MyntraImport from "app/pages/myntra/import";
import MyntraOrdersList from "app/pages/myntra/orders-list";
import MyntraReturnsList from "app/pages/myntra/returns";
import MyntraPayments from "app/pages/myntra/payments";
import MyntraProductReport from "app/pages/myntra/product-report";
import MyntraStatistics from "app/pages/myntra/statistics";
import MyntraStatisticsList from "app/pages/myntra/statistics/list";
import MyntraFinanceDashboard from "app/pages/myntra/finance-dashboard";
import MyntraMarketingExpenses from "app/pages/myntra/marketing-expenses";
import MyntraReturnReasonAnalysis from "app/pages/myntra/return-reason-analysis";
import MeeshoReturnReasonAnalysis from "app/pages/order-management/return-reason-analysis";
import FlipkartMenu from "app/pages/flipkart";
import FlipkartImport from "app/pages/flipkart/import";
import FlipkartOrdersList from "app/pages/flipkart/orders-list";
import FlipkartPayments from "app/pages/flipkart/payments";
import FlipkartProductReport from "app/pages/flipkart/product-report";
import FlipkartStatistics from "app/pages/flipkart/statistics";
import FlipkartStatisticsList from "app/pages/flipkart/statistics/list";
import FlipkartFinanceDashboard from "app/pages/flipkart/finance-dashboard";
import InventoryManagement from "app/pages/inventoryManagement";
import AppSalesReport from "../pages/app-sales-report";
import OrderLabelImport from "../pages/order-label-import";

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
  {
    path: HOME,
    element: (
      <PrivateRoute>
        <Page component={Home} />
      </PrivateRoute>
    ),
  },
  {
    path: "/401",
    element: (
      <PrivateRoute>
        <Page component={Error401} />
      </PrivateRoute>
    ),
  },
  {
    path: COLORS,
    element: (
      <PrivateRoute permission="list-color">
        <Page component={Color} />
      </PrivateRoute>
    ),
  },
  {
    path: SIZES,
    element: (
      <PrivateRoute permission="list-size">
        <Page component={Size} />
      </PrivateRoute>
    ),
  },
  {
    path: SIZE_CHARTS,
    element: (
      <PrivateRoute permission="size-chart-list">
        <Page component={SizeChart} />
      </PrivateRoute>
    ),
  },
  {
    path: INVENTORY_MANAGEMENT,
    element: (
      <PrivateRoute permission="inventory-list">
        <Page component={InventoryManagement} />
      </PrivateRoute>
    ),
  },
  {
    path: APP_SALES_REPORT,
    element: (
      <PrivateRoute permission="app-sales-report">
        <Page component={AppSalesReport} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_LABEL_IMPORT,
    element: (
      <PrivateRoute permission="order-label-list">
        <Page component={OrderLabelImport} />
      </PrivateRoute>
    ),
  },
  {
    path: FABRICS,
    element: (
      <PrivateRoute permission="list-fabric">
        <Page component={Fabric} />
      </PrivateRoute>
    ),
  },
  {
    path: PLATFORMS,
    element: (
      <PrivateRoute permission="list-platform">
        <Page component={Platform} />
      </PrivateRoute>
    ),
  },
  {
    path: EXPENSE_TYPE,
    element: (
      <PrivateRoute permission="list-expense-type">
        <Page component={ExpenseType} />
      </PrivateRoute>
    ),
  },
  {
    path: INCOME_TYPE,
    element: (
      <PrivateRoute permission="list-income-type">
        <Page component={IncomeType} />
      </PrivateRoute>
    ),
  },
  {
    path: PURCHASE_ORDERS,
    element: (
      <PrivateRoute permission="list-purchase-order">
        <Page component={PurchaseOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: PURCHASE_ORDERS_ADD,
    element: (
      <PrivateRoute permission="create-purchase-order">
        <Page component={AddAndUpdatePurchaseOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: PURCHASE_ORDERS_EDIT,
    element: (
      <PrivateRoute permission="update-purchase-order">
        <Page component={AddAndUpdatePurchaseOrder} />
      </PrivateRoute>
    ),
  },
  {
    path: BILL_LIST,
    element: (
      <PrivateRoute permission="list-bill">
        <Page component={BillList} />
      </PrivateRoute>
    ),
  },
  {
    path: BILL_ADD_From_PO,
    element: (
      <PrivateRoute permission="create-bill">
        <Page component={AddAndUpdateBill} />
      </PrivateRoute>
    ),
  },
  {
    path: BILL_ADD,
    element: (
      <PrivateRoute permission="create-bill">
        <Page component={AddAndUpdateBillOther} />
      </PrivateRoute>
    ),
  },
  {
    path: BILL_EDIT,
    element: (
      <PrivateRoute permission="update-bill">
        <Page component={AddAndUpdateBillOther} />
      </PrivateRoute>
    ),
  },
  {
    path: BILL_VIEW,
    element: (
      <PrivateRoute permission="list-bill">
        <Page component={AddAndUpdateBill} />
      </PrivateRoute>
    ),
  },
  {
    path: DEBIT_NOTE,
    element: (
      <PrivateRoute permission="create-billDebit">
        <Page component={DebitNote} />
      </PrivateRoute>
    ),
  },
  {
    path: DEBIT_NOTE_LIST,
    element: (
      <PrivateRoute permission="list-billDebit">
        <Page component={DebitNoteList} />
      </PrivateRoute>
    ),
  },
  {
    path: SALES_INVOICE,
    element: (
      <PrivateRoute permission="list-invoice">
        <Page component={SalesInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: SALES_INVOICE_ADD,
    element: (
      <PrivateRoute permission="create-invoice">
        <Page component={AddAndUpdateSalesInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: SALES_INVOICE_EDIT,
    element: (
      <PrivateRoute permission="update-invoice">
        <Page component={AddAndUpdateSalesInvoice} />
      </PrivateRoute>
    ),
  },
  {
    path: CATEGORIES,
    element: (
      <PrivateRoute permission="category-list">
        <Page component={Category} />
      </PrivateRoute>
    ),
  },
  {
    path: USERS,
    element: (
      <PrivateRoute permission="user-list">
        <Page component={User} />
      </PrivateRoute>
    ),
  },
  {
    path: USERS_ADD,
    element: (
      <PrivateRoute permission="user-create">
        <Page component={AddUser} />
      </PrivateRoute>
    ),
  },
  {
    path: USERS_EDIT,
    element: (
      <PrivateRoute permission="user-update">
        <Page component={AddUser} />
      </PrivateRoute>
    ),
  },
  {
    path: USERS_ATTENDANCE_LOG,
    element: (
      <PrivateRoute permission="user-list">
        <Page component={UserAttendanceList} />
      </PrivateRoute>
    ),
  },
  {
    path: ROLES,
    element: (
      <PrivateRoute permission="role-list">
        <Page component={Role} />
      </PrivateRoute>
    ),
  },
  {
    path: MANAGE_PERMISSION,
    element: (
      <PrivateRoute permission="permission-manage">
        <Page component={Permissions} />
      </PrivateRoute>
    ),
  },
  {
    path: "/change-password",
    element: (
      <PrivateRoute>
        <Page component={ChangePassword} />
      </PrivateRoute>
    ),
  },
  {
    path: VENDORS,
    element: (
      <PrivateRoute permission="list-vendor">
        <Page component={OfficeVendor} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCTS,
    element: (
      <PrivateRoute permission="list-product">
        <Page component={Product} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCT_EDIT,
    element: (
      <PrivateRoute permission="update-product">
        <Page component={AddProduct} />
      </PrivateRoute>
    ),
  },
  {
    path: PRODUCT_ADD,
    element: (
      <PrivateRoute permission="create-product">
        <Page component={AddProduct} />
      </PrivateRoute>
    ),
  },

  {
    path: PRODUCT_VARIANTS,
    element: (
      <PrivateRoute permission="list-variant">
        <Page component={ProductVariant} />
      </PrivateRoute>
    ),
  },
  {
    path: LOGS_URL,
    element: (
      <PrivateRoute permission="list-log">
        <Page component={Logs} />
      </PrivateRoute>
    ),
  },
  {
    path: CASH_BOOK,
    element: (
      <PrivateRoute permission="entry-book-list">
        <Page component={CashBookPage} />
      </PrivateRoute>
    ),
  },
  {
    path: CHEQUE_BOOK,
    element: (
      <PrivateRoute permission="entry-book-list">
        <Page component={ChequeBookPage} />
      </PrivateRoute>
    ),
  },
  {
    path: CASH_CREDIT_DEBIT,
    element: (
      <PrivateRoute permission="entry-book-create">
        <Page component={CreditAndDebit} />
      </PrivateRoute>
    ),
  },
  {
    path: CHEQUE_CREDIT_DEBIT,
    element: (
      <PrivateRoute permission="entry-book-create">
        <Page component={CreditAndDebit} />
      </PrivateRoute>
    ),
  },
  {
    path: LEDGER,
    element: (
      <PrivateRoute permission="report-ledger">
        <Page component={Ledger} />
      </PrivateRoute>
    ),
  },
  {
    path: PROFIT_LOSS,
    element: (
      <PrivateRoute permission="report-profit-loss">
        <Page component={ProfitLoss} />
      </PrivateRoute>
    ),
  },
  {
    path: OUTSTANDING_REPORT,
    element: (
      <PrivateRoute permission="report-paymnet-report">
        <Page component={PaymentReport} />
      </PrivateRoute>
    ),
  },
  {
    path: BALANCE_SHEET,
    element: (
      <PrivateRoute permission="report-balance-sheet">
        <Page component={BalanceSheet} />
      </PrivateRoute>
    ),
  },
  {
    path: UNIT_ECONOMICS,
    element: (
      <PrivateRoute permission="ue-calculator">
        <Page component={FlipkartUnitEconomics} />
      </PrivateRoute>
    ),
  },
  {
    path: SAMPLES,
    element: (
      <PrivateRoute permission="list-sample">
        <Page component={SampleManagement} />
      </PrivateRoute>
    ),
  },
  {
    path: SAMPLES_ADD,
    element: (
      <PrivateRoute permission="create-sample">
        <Page component={AddEditSample} />
      </PrivateRoute>
    ),
  },
  {
    path: SAMPLES_EDIT,
    element: (
      <PrivateRoute permission="update-sample">
        <Page component={AddEditSample} />
      </PrivateRoute>
    ),
  },
  {
    path: SAMPLES_RETURN,
    element: (
      <PrivateRoute permission="return-sample">
        <Page component={ReturnSample} />
      </PrivateRoute>
    ),
  },
  {
    path: SAMPLES_RETURN_LIST,
    element: (
      <PrivateRoute permission="list-sample">
        <Page component={SampleManagementReturn} />
      </PrivateRoute>
    ),
  },
  {
    path: AUDITS,
    element: (
      <PrivateRoute permission="list-audit">
        <Page component={Audit} />
      </PrivateRoute>
    ),
  },
  {
    path: AUDITS_ADD,
    element: (
      <PrivateRoute permission="create-audit">
        <Page component={AddEditAudit} />
      </PrivateRoute>
    ),
  },
  {
    path: AUDITS_LIST,
    element: (
      <PrivateRoute permission="list-audit">
        <Page component={AuditList} />
      </PrivateRoute>
    ),
  },
  {
    path: MEESHO,
    element: (
      <PrivateRoute>
        <Page component={MeeshoMenu} />
      </PrivateRoute>
    ),
  },
  {
    path: MEESHO_DASHBOARD,
    element: (
      <PrivateRoute>
        <Page component={MeeshoDashboard} />
      </PrivateRoute>
    ),
  },
  {
    path: MEESHO_BULK_IMPORT,
    element: (
      <PrivateRoute>
        <Page component={MeeshoBulkImport} />
      </PrivateRoute>
    ),
  },
  {
    path: MEESHO_PAYMENT_IMPORT,
    element: (
      <PrivateRoute>
        <Page component={MeeshoPaymentImport} />
      </PrivateRoute>
    ),
  },
  {
    path: MEESHO_ORDERS_LIST,
    element: (
      <PrivateRoute>
        <Page component={MeeshoOrdersList} />
      </PrivateRoute>
    ),
  },
  {
    path: MEESHO_RTO,
    element: (
      <PrivateRoute>
        <Page component={MeeshoRTO} />
      </PrivateRoute>
    ),
  },
  {
    path: MEESHO_REPORT,
    element: (
      <PrivateRoute>
        <Page component={MeeshoReport} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT,
    element: (
      <PrivateRoute>
        <Page component={OrderManagement} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_IMPORT,
    element: (
      <PrivateRoute permission="import-meesho-files">
        <Page component={OrderImport} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_ORDER_HISTORY,
    element: (
      <PrivateRoute permission="import-list">
        <Page component={OrderHistory} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_PAYMENT_MARKETING_EXPENSES_HISTORY,
    element: (
      <PrivateRoute permission="import-list">
        <Page component={OrderMarketingExpensesHistory} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_LIST,
    element: (
      <PrivateRoute permission="order-list">
        <Page component={OrderList} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_STATISTICS,
    element: (
      <PrivateRoute permission="meesho-statistics">
        <Page component={OrderStatistics} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_STATISTICS_LIST,
    element: (
      <PrivateRoute permission="meesho-statistics">
        <Page component={OrderStatisticsList} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_RETURNS,
    element: (
      <PrivateRoute permission="return-list">
        <Page component={ReturnsList} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_PAYMENT_PROCESS,
    element: (
      <PrivateRoute permission="meesho-payment-list">
        <Page component={PaymentList} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_MARKETING_EXPENSES,
    element: (
      <PrivateRoute permission="meesho-ads-list">
        <Page component={MarkingExpensesList} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_PRODUCT_REPORT,
    element: (
      <PrivateRoute permission="meesho-product-report">
        <Page component={ProductReportList} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_FINANCE_DASHBOARD,
    element: (
      <PrivateRoute permission="meesho-finance-dashboard">
        <Page component={FinanceDashboard} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_PAYOUT_BREAKDOWN,
    element: (
      <PrivateRoute permission="meesho-payout-breakdown">
        <Page component={PayoutBreakdown} />
      </PrivateRoute>
    ),
  },
  {
    path: ATTENDANCE_QR,
    element: (
      <PrivateRoute permission="attendance-list">
        <Page component={Attendance} />
      </PrivateRoute>
    ),
  },
  // Flipkart Routes
  {
    path: FLIPKART,
    element: (
      <PrivateRoute>
        <Page component={FlipkartMenu} />
      </PrivateRoute>
    ),
  },
  {
    path: FLIPKART_IMPORT,
    element: (
      <PrivateRoute permission="flipkart-import">
        <Page component={FlipkartImport} />
      </PrivateRoute>
    ),
  },
  {
    path: FLIPKART_ORDERS_LIST,
    element: (
      <PrivateRoute permission="flipkart-order-list">
        <Page component={FlipkartOrdersList} />
      </PrivateRoute>
    ),
  },
  {
    path: FLIPKART_PAYMENTS,
    element: (
      <PrivateRoute permission="flipkart-payment-list">
        <Page component={FlipkartPayments} />
      </PrivateRoute>
    ),
  },
  {
    path: FLIPKART_PRODUCT_REPORT,
    element: (
      <PrivateRoute permission="flipkart-product-report">
        <Page component={FlipkartProductReport} />
      </PrivateRoute>
    ),
  },
  {
    path: FLIPKART_STATISTICS,
    element: (
      <PrivateRoute permission="flipkart-statistics">
        <Page component={FlipkartStatistics} />
      </PrivateRoute>
    ),
  },
  {
    path: FLIPKART_STATISTICS_LIST,
    element: (
      <PrivateRoute permission="flipkart-statistics">
        <Page component={FlipkartStatisticsList} />
      </PrivateRoute>
    ),
  },
  {
    path: FLIPKART_FINANCE_DASHBOARD,
    element: (
      <PrivateRoute permission="flipkart-finance-dashboard">
        <Page component={FlipkartFinanceDashboard} />
      </PrivateRoute>
    ),
  },
  // Myntra Routes
  {
    path: MYNTRA,
    element: (
      <PrivateRoute>
        <Page component={MyntraMenu} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_IMPORT,
    element: (
      <PrivateRoute permission="myntra-import">
        <Page component={MyntraImport} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_ORDERS_LIST,
    element: (
      <PrivateRoute permission="myntra-order-list">
        <Page component={MyntraOrdersList} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_RETURNS,
    element: (
      <PrivateRoute permission="myntra-return-list">
        <Page component={MyntraReturnsList} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_PAYMENTS,
    element: (
      <PrivateRoute permission="myntra-payment-list">
        <Page component={MyntraPayments} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_PRODUCT_REPORT,
    element: (
      <PrivateRoute permission="myntra-product-report">
        <Page component={MyntraProductReport} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_STATISTICS,
    element: (
      <PrivateRoute permission="myntra-statistics">
        <Page component={MyntraStatistics} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_STATISTICS_LIST,
    element: (
      <PrivateRoute permission="myntra-statistics">
        <Page component={MyntraStatisticsList} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_FINANCE_DASHBOARD,
    element: (
      <PrivateRoute permission="myntra-finance-dashboard">
        <Page component={MyntraFinanceDashboard} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_MARKETING_EXPENSES,
    element: (
      <PrivateRoute permission="myntra-marketing-expenses">
        <Page component={MyntraMarketingExpenses} />
      </PrivateRoute>
    ),
  },
  {
    path: MYNTRA_RETURN_REASON_ANALYSIS,
    element: (
      <PrivateRoute permission="myntra-return-list">
        <Page component={MyntraReturnReasonAnalysis} />
      </PrivateRoute>
    ),
  },
  {
    path: ORDER_MANAGEMENT_RETURN_REASON_ANALYSIS,
    element: (
      <PrivateRoute permission="meesho-return-reason">
        <Page component={MeeshoReturnReasonAnalysis} />
      </PrivateRoute>
    ),
  },
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
  {
    path: "/login",
    element: <Page component={Login} layout={"solo-page"} />,
  },
  {
    path: "/reset-password",
    element: <Page component={ResetPassword} layout={"solo-page"} />,
  },
  {
    path: "/set-password",
    element: <Page component={SetPassword} layout={"solo-page"} />,
  },
  {
    path: "*",
    element: (
      <Page component={Error404} layout={"solo-page"} disableSmLogin={true} />
    ),
  },
];

const routes = [
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
];

export {
  routes as default,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
};
